import React from "react";
import { Toggle } from "@/modern/components/ui/toggle";
import { ScanEye, Scan } from "lucide-react";

interface EditorWarRoomToggleProps {
  pressed: boolean;
  onPressedChange: (pressed: boolean) => void;
}

export const EditorWarRoomToggle = ({ pressed, onPressedChange }: EditorWarRoomToggleProps) => {
  return (
    <Toggle
      variant="outline"
      size="sm"
      pressed={pressed}
      onPressedChange={onPressedChange}
      aria-label="Toggle War Room sizing"
    >
      {pressed ? <ScanEye className="size-4" /> : <Scan className="size-4" />}
      {pressed ? "War Room" : "Standard"}
    </Toggle>
  );
};
